<template>
  <div class="integral-record white border-radius10 page-box">
    <div class="header">
      <el-date-picker
        v-if="!realMobile"
        style="width: 260px"
        class="mar-bot10 header-item"
        size="small"
        v-model="pickerTime"
        type="daterange"
        align="left"
        value-format="yyyy-MM-dd HH:mm:ss"
        unlink-panels
        :range-separator="phFileter('root.dateTo')"
        :start-placeholder="phFileter('root.startDate')"
        :end-placeholder="phFileter('root.endDate')"
      >
      </el-date-picker>
      <select-date-duration
        class="header-item"
        v-model="pickerTime"
      ></select-date-duration>
      <el-select
        style="width: 120px"
        size="small"
        class="query-status mar-bot10 header-item"
        v-model="status"
        clearable
        :placeholder="phFileter('User.status')"
      >
        <el-option
          v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-button
        class="mar-bot10"
        size="small"
        type="primary"
        @click="queryHandle"
      >{{$t('root.search')}}</el-button>
      <el-button
        class="mar-bot10"
        size="small"
        @click="clearHandle"
      >{{$t('withgold.clearEmipt')}}</el-button>
    </div>
    <div class="page-content">
      <div class="vs-table-outer">
        <vs-table :noDataText="$t('root.noData')" :data="listData">
          <template
            slot="thead"
          >
            <vs-th>
              {{$t('User.num')}}
            </vs-th>
            <vs-th>
              {{$t('Redeem_products')}}
            </vs-th>

            <vs-th>
              {{$t('quantity')}}
            </vs-th>
            <vs-th>
              {{$t('Deduct_points')}}
            </vs-th>
            <vs-th>
              {{$t('Exchange_time')}}
            </vs-th>

            <vs-th>
              {{$t('User.status')}}
            </vs-th>
            <vs-th>
              {{$t('operate')}}
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr style="background-color:#F3F2F7;">
              <vs-td>
                {{$t('total')}}
              </vs-td>
              <vs-td>
                {{'-'}}
              </vs-td>
              <vs-td>
                {{'-'}}
              </vs-td>
              <vs-td>
                {{statistics.transConsumedPoint}}
              </vs-td>
              <vs-td>
                {{'-'}}
              </vs-td>
              <vs-td>
                {{'-'}}
              </vs-td>
              <vs-td>
                {{'-'}}
              </vs-td>
            </vs-tr>
            <vs-tr :key="index" v-for="(tr, index) in data">
              <vs-td>
                {{tr.id}}
              </vs-td>
              <vs-td>
                {{tr.productName}}
              </vs-td>

              <vs-td>
                {{tr.quantity}}
              </vs-td>
              <vs-td>
                {{tr.consumedPoint}}
              </vs-td>
              <vs-td>
                {{tr.createTime}}
              </vs-td>

              <vs-td>
                <span>{{getStatus(tr)}}<i v-if="tr.status == 3">{{tr.rejectRason}}</i></span>
              </vs-td>
              <vs-td>
                <span class="pointer" @click="checkView(tr)">{{$t('copyMaster.view_the_details')}}</span>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>

      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <exchange-detail
      :dialog-show="exchangeDialogShow"
      @close="closeExchangeDialog"
      :detail-data="currentRow"
    ></exchange-detail>
  </div>
</template>

<script>
import exchangeDetail from '@/components/integral/exchangeDetail';
import  { mapGetters } from 'vuex';
import { parseTime } from '@/utils/index'
import { limitNumber } from '@/utils/validate'
import initData from '@/mixins/initData';
import { parseStatus } from '@/utils/common';
export default {
  name: 'integralRecord',
  components:{
    exchangeDetail
  },
  data() {
    let _this = this;
    return {
      statusList:[
        {
          value: 1,
          label: _this.$t('withgold.withgoldOut1')
        },
        {
          value: 2,
          label: _this.$t('Audit_Reject')
        },
        {
          value: 3,
          label: _this.$t('User.authPass'),
        },
      ],
      data:[],
      status: '',
      pickerTime: '',
      statistics: {
        transConsumedPoint: '',
      },
      exchangeDialogShow: false,
      currentRow:{}
    }
  },
  mixins: [initData],
  created(){
    this.$nextTick(() => {
      this.init();
    })
  },
  computed: {
    ...mapGetters(['language','userInfo','realMobile']),
  },
  methods: {
    parseTime,
    parseStatus,
    getStatus(item){
      switch (item.status){
        case 1:
          return this.$t('withgold.withgoldOut1');
        case 2:
          return this.$t('User.authPass');
        case 3:
          return this.$t('User.authPass');
      }
    },
    beforeInit(){
      this.url = '/crm/reception/rewardRedeemRecord';
      this.params = {
        page: this.page - 1,
        size: this.size,
      };
      if(this.type){
        this.params.type = this.type;
      }
      if(this.status){
        this.params.status = this.status;
      }
      if(this.pickerTime){
        this.params.startTime = this.pickerTime[0];
        this.params.endTime = this.pickerTime[1];
      }
      return true;
    },
    phFileter(data){
      return this.$t(data)
    },
    //  清空
    clearHandle(){
      this.type = '';
      this.pickerTime = '';
      this.status = '';
    },
    queryHandle(){
      this.page = 1;
      this.init();
    },
    getStatusMinWidth(){
      if(this.language == 'en_US'){
        return '150px';
      }else {
        return '';
      }
    },
    checkView(row){
      this.currentRow = row;
      this.exchangeDialogShow = true;
    },
    closeExchangeDialog(){
      this.exchangeDialogShow = false;
    }
  },
};
</script>
<style lang="scss">
.integral-record {
  .el-date-editor--daterange.el-input__inner {
    width: 100%;
  }
}
</style>
<style scoped lang="scss">
.integral-record{
  min-height: 500px;
  .header {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    .header-item {
      margin-right: 5px;
    }
  }
  .pagination-outer {
    padding-left: 0;
  }
}
</style>
